import styled from 'styled-components';
import { Header, Text } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: white;
  padding: 20px;
  border-radius: 4px;
`;

export const TableHeader = styled.div`
  display: flex;
  && .ui.header {
    margin: 0 0 10px 0;
  }
`;

export const TableHeaderTitle = styled(Header)`
  flex: 1;
  font-weight: 500;
`;

export const ContainerCardName = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const CardName = styled(Text)`
  font-weight: 500;
  word-break: break-word;
`;

export const ContainerCardNameImage = styled.div`
  background-color: ${(props) => props.theme.color.analyticsCardSortBackground};
  padding: 5px;
  border-radius: 4px;
  margin: 10px;
  height: min-content;
`;

export const Image = styled.img`
  max-height: 90px;
  max-width: 150px;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 0;
  word-break: break-all;
  ${(props) => (props.noBorder ? '' : 'border-top: 1px solid rgba(0,0,0,.1);')};
  :hover {
    background-color: ${(props) => props.theme.color.rowHover};
  }
`;
